// Each link: { title, url, description }
export const RESOURCE_SECTIONS = [
  { id: 'awareness', title: 'Awareness', links: [] },
  { id: 'preparedness', title: 'Preparedness', links: [] },
  { id: 'mitigation', title: 'Mitigation', links: [] },
  { id: 'response', title: 'Response', links: [] },
  { id: 'recovery', title: 'Recovery', links: [] },
];
